module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// d:/xampp/htdocs/zenith-admin/~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.woff2
// module chunks = 2